import { InnerContentWrap } from "@tm/ui-widgets";
import { usePartnerContext } from "@tm/ui-widgets/hooks";
import { SeoContentStyle } from "./SeoContent.style";

interface SeoContentProps {
  seoContent: string;
}

const SeoContent = ({ seoContent }: SeoContentProps) => {
  const context = usePartnerContext();
  return (
    <SeoContentStyle pageTheme={context ? context : undefined}>
      <InnerContentWrap
        dangerouslySetInnerHTML={{ __html: seoContent }}
      ></InnerContentWrap>
    </SeoContentStyle>
  );
};

export default SeoContent;
